export default __webpack_public_path__ + "static/media/miezeBody.9a671116.png";